import React, { SVGProps } from 'react';

export const EjectNewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M17.997 14.75H6.003a2.72 2.72 0 0 1-2.496-1.605 2.741 2.741 0 0 1 .416-2.961L9.92 3.207c1.042-1.216 3.117-1.218 4.162 0l5.995 6.977c.714.83.873 1.965.416 2.96a2.72 2.72 0 0 1-2.496 1.606Zm-5.996-11c-.362 0-.707.158-.943.435L5.06 11.162a1.241 1.241 0 0 0-.189 1.358c.21.458.634.73 1.133.73h11.994c.5 0 .923-.273 1.133-.73a1.241 1.241 0 0 0-.189-1.358l-5.996-6.977h-.001a1.245 1.245 0 0 0-.944-.435Zm6.8 18H5.2c-1.221 0-1.95-.729-1.95-1.95v-1.6c0-1.221.729-1.95 1.95-1.95h13.6c1.221 0 1.95.729 1.95 1.95v1.6c0 1.221-.729 1.95-1.95 1.95Zm-13.601-4c-.387 0-.45.063-.45.45v1.6c0 .387.063.45.45.45h13.6c.387 0 .45-.063.45-.45v-1.6c0-.387-.063-.45-.45-.45H5.2Z"
    />
  </svg>
);
